import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Avatar from '@material-ui/core/Avatar';
import Toolbar from '@material-ui/core/Toolbar';
import CircularProgress from '@material-ui/core/CircularProgress';
import Tooltip from '@material-ui/core/Tooltip';
import HelpIcon from '@material-ui/icons/HelpOutline';

const styles = theme => ({
  paper: {
    textAlign: 'center',
    color: theme.palette.text.secondary,
  },
  helpIcon: {
    marginLeft: theme.spacing(1),
  }
});

class Sold extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      cards: [],
    }

    this.getSold = this.getSold.bind(this);
  }

  componentDidMount() {
    this.getSold(0,20)
    this.timer = setInterval(()=> this.getSold(0,20), 15000);
  }

  componentWillUnmount() {
    clearInterval(this.timer)
    this.timer = null;
  }

  getSold = (offset, limit) => {
    fetch('https://api.opensea.io/api/v1/events?asset_contract_address=0x0e3a2a1f2146d86a604adc220b4967a898d7fe07&event_type=successful&limit=100')
    .then(res => {
      return res.json()
    }).then(data => {
      let cards = data.asset_events.map((card) => {
        let asset = card.asset
        return(asset ? { name: asset.name.substring(0, asset.name.indexOf("ID #")), tokenId: asset.token_id, thumbnail: asset.image_thumbnail_url, preview: asset.image_preview_url, price: card.total_price/1000000000000000000, time: card.event_timestamp, marketplace: card.relayer ? card.relayer : 'Immutable' } : {})
      })
      this.setState({cards: cards})
    })
  }

  render() {
    const { classes } = this.props;
    let currentTime = Date.now();

    return (
      <React.Fragment>
        <Grid item xs={12}>
          <Paper className={classes.paper}>
            {/* <Toolbar>
              <Tooltip className={classes.helpIcon} placement="right" title="Shows OpenSea events which includes sold listings from both OpenSea and TokenTrove. Auto refreshes every 15s">
                <HelpIcon fontSize="small" />
              </Tooltip>
            </Toolbar> */}
            {this.state.cards.length <= 0 &&
              <CircularProgress />
            }
            {this.state.cards.length > 0 &&
              <Table size="small">
                <TableHead>
                  <TableRow>
                    <TableCell></TableCell>
                    <TableCell>Name</TableCell>
                    <TableCell>Marketplace</TableCell>
                    <TableCell>Price (ETH)</TableCell>
                    <TableCell>Time Past</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {this.state.cards.map((card, index) => {
                    let cardTime = new Date(card.time);
                    cardTime.setHours(cardTime.getHours() - 8);

                    let diff = currentTime - cardTime;
                    let minutes = Math.floor(diff/60000);
                    let seconds = Math.floor(diff/1000);
                    return (
                      <TableRow hover key={index}>
                        <TableCell><Avatar variant="square" alt={card.name} src={card.thumbnail} /></TableCell>
                        <TableCell>{card.name}</TableCell>
                        <TableCell>{card.marketplace}</TableCell>
                        <TableCell>{card.price ? card.price.toFixed(4) : card.price}</TableCell>
                        <TableCell>{minutes > 0 ? minutes + ' mins' : seconds + ' secs'}</TableCell>
                      </TableRow>
                    );
                  })}
                </TableBody>
              </Table>
            }
          </Paper>
        </Grid>
      </React.Fragment>
    );
  }
}

Sold.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(Sold);